import { IspInspectionLogbackHeaderComponent } from '@one/app/pages/isp/shared/components/isp-logback-header/isp-inspection-logback-header.component';
import { IspManualOfflineBannerComponent } from '@one/app/pages/isp/shared/components/isp-manual-offline-banner/isp-manual-offline-banner.component';
import { resetIspStickyLayoutVars, setIspOfflineBannerHeight } from '@one/app/pages/isp/shared/functions/isp-sticky-layout.util';
import { ChangeDetectionStrategy, Component, ElementRef, input, OnDestroy, OnInit, inject } from '@angular/core';

@Component({
  selector: 'one-isp-session-chrome',
  standalone: true,
  imports: [IspManualOfflineBannerComponent, IspInspectionLogbackHeaderComponent],
  templateUrl: './isp-session-chrome.component.html',
  styleUrl: './isp-session-chrome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IspSessionChromeComponent implements OnInit, OnDestroy {
  public readonly showLogbackHeader = input(false);

  private readonly _elementRef = inject(ElementRef<HTMLElement>);
  private _resizeObserver: ResizeObserver | undefined;

  public ngOnInit(): void {
    resetIspStickyLayoutVars();
    this._resizeObserver = new ResizeObserver((): void => {
      this._publishChromeHeight();
    });
    this._resizeObserver.observe(this._elementRef.nativeElement);
  }

  public ngOnDestroy(): void {
    this._resizeObserver?.disconnect();
    resetIspStickyLayoutVars();
  }

  private _publishChromeHeight(): void {
    const height = this._elementRef.nativeElement.getBoundingClientRect().height;

    setIspOfflineBannerHeight(`${height}px`);
  }
}
